import { useEffect } from "react";
import {
  useAskRitesh,
  AskRiteshForm,
  QuestionCard,
  LiveCounter,
} from "./AskRitesh";

export default function QuestionsPage() {
  const { questions, stats, refresh } = useAskRitesh({ pollInterval: 15000 });

  useEffect(() => {
    document.title =
      "Ask Ritesh — Public Q&A Wall | Rubiemaze Inc";
  }, []);

  return (
    <section
      data-testid="questions-page"
      className="relative min-h-screen bg-[#030303] pt-32 md:pt-40 pb-20 md:pb-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14 md:mb-16">
          <div className="lg:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
              The Public Q&amp;A Wall
            </div>
            <h1 className="font-display text-white text-[36px] sm:text-5xl md:text-7xl lg:text-[88px] leading-[0.98] tracking-[-0.02em] uppercase">
              Ask Ritesh a question about{" "}
              <em className="font-editorial italic text-[#D4AF37] font-light normal-case">
                your business.
              </em>
            </h1>
          </div>
          <div className="lg:col-span-4 text-white/60 text-sm md:text-base leading-relaxed lg:pl-6">
            Anyone can post. Only Ritesh replies. Every question is moderated
            before it appears here — no spam, no anonymous noise.
          </div>
        </div>

        <LiveCounter stats={stats} />

        <div className="mt-10 md:mt-14 max-w-3xl">
          <AskRiteshForm onSubmitted={refresh} />
        </div>

        <div className="mt-14 md:mt-20">
          <div className="text-[11px] uppercase tracking-[0.28em] text-white/60 mb-6 md:mb-8">
            All questions ({questions.length})
          </div>

          {questions.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-white/12 bg-white/[0.015] p-10 md:p-14 text-center">
              <div className="font-display text-white text-2xl">
                No questions on the wall yet.
              </div>
              <p className="mt-3 text-white/55 text-sm max-w-md mx-auto">
                Be the first to ask.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {questions.map((q, i) => (
                <QuestionCard key={q.id} q={q} idx={i} />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
